import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Homepage from "./pages/Homepage";
import Services from "./pages/Services";
import Documents from "./pages/Documents";
import FAQ from "./pages/FAQ";
import LocationsOverview from "./pages/LocationsOverview";
import LocationDetail from "./pages/LocationDetail";
import FloatingButtons from "./components/FloatingButtons";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/locations" element={<LocationsOverview />} />
            <Route path="/location/:locationName" element={<LocationDetail />} />
          </Routes>
        </main>
        <Footer />
        <FloatingButtons />
      </BrowserRouter>
    </div>
  );
}

export default App;